export default function newSyncableEndnoteChangeDirective() {
  return {
    template: require('./new-syncable-endnote-change.html'),
    restrict: 'E',
    controller: 'NewSyncableEndnoteChangeController',
    controllerAs: 'newSyncableEndnoteChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
    },
  };
}
